const VERIFIER_LENGTH = 64;
const CHARSET =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";

export function generateVerifier(): string {
  const bytes = new Uint8Array(VERIFIER_LENGTH);
  crypto.getRandomValues(bytes);
  let result = "";
  for (let i = 0; i < VERIFIER_LENGTH; i++) {
    result += CHARSET[bytes[i]! % CHARSET.length];
  }
  return result;
}

export async function generateChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64UrlEncode(digest);
}

export async function generatePKCEPair(): Promise<{
  verifier: string;
  challenge: string;
}> {
  const verifier = generateVerifier();
  const challenge = await generateChallenge(verifier);
  return { verifier, challenge };
}

function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
